// Pure helpers shared by the Data sources page and the datafeed inspector.
// A data source resolves to an array of flat objects; a datafeed widget's
// columns name the fields of those objects. Everything here is about getting
// from one to the other, so it is kept out of the components and tested.

// The row keys a source actually returns — what a datafeed's columns must match.
export function rowKeys(data) {
  const first = Array.isArray(data) ? data[0] : data;
  if (!first || typeof first !== 'object' || Array.isArray(first)) return [];
  return Object.keys(first);
}

export function rowCount(data) {
  if (Array.isArray(data)) return data.length;
  return data == null ? 0 : 1;
}

// Columns are edited as "key | Header" lines — the same shape as the list
// widget's items, so the two inspectors read the same way.
export function columnsToText(columns) {
  return (columns || [])
    .map((c) => (c.header && c.header !== c.key ? `${c.key} | ${c.header}` : c.key || ''))
    .join('\n');
}

export function textToColumns(text, existing = []) {
  const byKey = new Map((existing || []).map((c) => [c.key, c]));
  return (text || '').split('\n').map((line) => line.trim()).filter(Boolean).map((line) => {
    const [key, ...rest] = line.split('|');
    const k = key.trim();
    const header = rest.join('|').trim() || k;
    // Keep any styling (flex/color/align) already set on a column of this name.
    return { ...(byKey.get(k) || { flex: '1' }), key: k, header };
  });
}

// Turn a source's field names into presentable column headers.
export function columnsFromKeys(keys) {
  return (keys || []).map((k) => ({ key: k, header: k.replace(/_/g, ' ').toUpperCase(), flex: '1' }));
}
